// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "content_item_message".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { contentBatchItemMessageRoleValues } from '@borradh-workspace/labels';
/** Response atom for the "content_item_message" table (1:1 with a DB row, on the wire). */
export const contentItemMessageAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    batchId: z.string().nullable(),
    itemId: z.string(),
    role: z.enum(contentBatchItemMessageRoleValues),
    content: z.string(),
    captionSnapshot: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=contentItemMessage.js.map